import { setUserData } from '@/store/actions';
import { apiService } from './apiService';
import ToastMe from '@/components/ui/ToastMe';

export function getAdminService(data) {
    return apiService({
        method: 'POST',
        url: '/admin-user/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdAdminService(id) {
    return apiService({
        method: 'GET',
        url: '/admin-user/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getAdminDataService(id) {
    return apiService({
        method: 'GET',
        url: '/admin-user/user/' + id,
        onSuccess: (dispatch, res) => {
            dispatch(setUserData(res));
        },
        onFailure: () => {},
    });
}

export function addAdminService(data) {
    return apiService({
        method: 'POST',
        url: '/admin-user',
        data,
        onSuccess: (dispatch, res) => {
            ToastMe(res?.data?.message);
        },
        onFailure: () => {},
    });
}

export function updateAdminService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/admin-user/' + id,
        data,
        onSuccess: (dispatch, res) => {
            ToastMe(res?.data?.message);
        },
        onFailure: () => {},
    });
}

// src/services/AdminServices.js
export function updateAdminPasswordService(data) {
  return apiService({
    method: 'PUT',
    url: '/admin-user/password',   // ← no :id
    data,
    onSuccess: (dispatch, res) => {
      ToastMe(res?.data?.message || 'Password updated successfully');
    },
  });
}


export function deleteAdminService(id) {
    return apiService({
        method: 'DELETE',
        url: '/admin-user/' + id,
        onSuccess: (dispatch, res) => {
            ToastMe(res?.data?.message);
        },
        onFailure: () => {},
    });
}
// src/services/AdminServices.js  (add just this function)
export function updateAdminPhotoService(id, data) {
  return apiService({
    method: 'PUT',
    url   : '/admin-user/photo/' + id,   // ↔ matches router.put('/photo/:id')
    data,
    onFailure: () => {},
  });
}
